export default __webpack_public_path__ + "static/media/google-black.d7f8b101.webp";